import { isProfessional, isClient, isFreeProfessional } from '../helpers/auth';
/**
 * mouseflow
 * Custom Variables / Tagging
 * https://mouseflow.freshdesk.com/support/solutions/articles/44001534908-custom-variables-tagging
 */
class MouseFlowAnalytics {
    constructor() {
        /**
         * ログイン種別の設定
         * @param type
         */
        this.setLoginTypeMfqVariables = (type) => {
            /* eslint-disable no-underscore-dangle */
            window._mfq = window._mfq || [];
            window._mfq.push(['setVariable', 'loginType', type]);
            /* eslint-enable no-underscore-dangle */
        };
        /**
         * ログイン種別の取得
         * @param auth
         */
        this.setLoginType = (auth) => {
            this.setLoginTypeMfqVariables(this.getLoginType(auth));
        };
        /**
         * ログイン種別の取得
         * @param auth
         * @returns {string}
         */
        this.getLoginType = (auth) => {
            if (isProfessional(auth) || isFreeProfessional(auth)) {
                return 'professionals';
            }
            if (isClient(auth)) {
                return 'clients';
            }
            return 'guest';
        };
    }
}
export default new MouseFlowAnalytics();
